import { rankingItems } from '@/mocks/homeData';

export default function RankingSection() {
  const getTrendIcon = (trend: string) => {
    if (trend === 'up') return 'ri-arrow-up-line text-accent-600';
    if (trend === 'down') return 'ri-arrow-down-line text-foreground-400';
    return 'ri-subtract-line text-foreground-400';
  };

  const getRankBadge = (rank: number) => {
    if (rank === 1) return 'bg-accent-500 text-white';
    if (rank === 2) return 'bg-primary-500 text-white';
    if (rank === 3) return 'bg-secondary-500 text-white';
    return 'bg-foreground-100 text-foreground-600';
  };

  return (
    <section id="ranking" className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-screen-2xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">热度榜单</h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            实时更新全网最热影视排名，看看你追的剧排第几
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          {rankingItems.map((item, index) => (
            <div
              key={item.id}
              className="flex items-center gap-4 py-4 px-4 rounded-lg hover:bg-background-200/70 transition-colors cursor-pointer border-b border-background-200/70 last:border-b-0"
              style={{ animation: `fadeInUp 0.4s ease-out ${index * 0.08}s both` }}
            >
              <div
                className={`w-8 h-8 flex items-center justify-center rounded-lg text-sm font-bold flex-shrink-0 ${getRankBadge(item.rank)}`}
              >
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="font-heading text-base text-foreground-950">{item.title}</div>
                <div className="text-xs text-foreground-400">{item.category}</div>
              </div>
              <div className="flex items-center gap-3 flex-shrink-0">
                <span className="font-heading text-lg text-foreground-800">{item.heat}</span>
                <span className="flex items-center gap-0.5 text-xs">
                  <i className={getTrendIcon(item.trend)}></i>
                  <span className={item.trend === 'up' ? 'text-accent-600' : item.trend === 'down' ? 'text-foreground-400' : 'text-foreground-400'}>
                    {item.change}
                  </span>
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}